import { useParams } from "react-router-dom"
import { CompareSchedules } from "routes/schedule/compare/compare-schedules"

export function Compare2() {
    const { destination, source } = useParams()
    return <CompareSchedules key={`${destination}/${source}`} />
}
